import React from 'react'
import { Navbar } from '../layouts/Navbar'
import { Footer } from '../layouts/Footer'
import { AboutHeader } from '../components/shared/About/AboutHeader'
import { Founders } from '../components/shared/About/Founders'
import { Mentors } from '../components/shared/About/Mentors'
import { ContactSales } from '../components/shared/ContactSales'

export const About = () => {
    return (
        <>
            <Navbar />
            <AboutHeader />
            <Founders />
            <Mentors />
            <ContactSales />
            <Footer header={["We are a team set to revolutionize", "the future of technology"]} />
        </>
    )
}
